import { ref } from 'vue'

interface RateLimitOptions {
  maxRequests: number
  windowMs: number
}

export const useRateLimit = (options: RateLimitOptions) => {
  const { maxRequests, windowMs } = options

  const requestHistory = ref<number[]>([])

  const canExecute = (): boolean => {
    const now = Date.now()

    requestHistory.value = requestHistory.value.filter(
      timestamp => now - timestamp < windowMs,
    )

    return requestHistory.value.length < maxRequests
  }

  const record = (): void => {
    requestHistory.value.push(Date.now())
  }

  const reset = (): void => {
    requestHistory.value = []
  }

  const getRemainingRequests = (): number => {
    const now = Date.now()
    requestHistory.value = requestHistory.value.filter(
      timestamp => now - timestamp < windowMs,
    )

    return Math.max(0, maxRequests - requestHistory.value.length)
  }

  return {
    canExecute,
    record,
    reset,
    getRemainingRequests,
  }
}
